import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IUnitNetworkTypeModel } from '@apps-common/types/portal/unit'

export const QUERY_KEY_GET_UNIT_NETWORK_TYPES = () => ['getUnitNetworkTypes']

export const getUnitNetworkTypes = async (): Promise<IUnitNetworkTypeModel[]> =>
  axios.get('/Unit/GetNetworkTypes').then((res) => res.data?.data)

type QueryFnType = typeof getUnitNetworkTypes

type Props = {
  config?: QueryConfig<QueryFnType>
}

export const useGetUnitNetworkTypes = ({ config }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: QUERY_KEY_GET_UNIT_NETWORK_TYPES(),
    queryFn: () => getUnitNetworkTypes()
  })
